import { DialogsProvider } from '@toolpad/core/useDialogs';

import Header from './Header';
import Pinned from './Pinned';
import Teams from './Teams';
import { Container } from './styled';

function Sidebar() {
  return (
    <DialogsProvider>
      <Container>
        <Header />
        <Teams />
        <Pinned />
      </Container>
    </DialogsProvider>
  );
}

export default Sidebar;
